export function Stamp({ className = "", label = "SZN TRIP · APPROVED · PUNTA CANA 2027 · " }) {
  return (
    <div
      className={`pointer-events-none select-none ${className}`}
      aria-hidden="true"
      data-testid="billet-stamp"
    >
      <svg viewBox="0 0 120 120" className="stamp-spin h-full w-full">
        <defs>
          <path
            id="stamp-circle"
            d="M60,60 m-42,0 a42,42 0 1,1 84,0 a42,42 0 1,1 -84,0"
          />
        </defs>
        <circle cx="60" cy="60" r="56" fill="none" stroke="#EA7A4F" strokeWidth="2" />
        <circle cx="60" cy="60" r="30" fill="none" stroke="#EA7A4F" strokeWidth="1.5" strokeDasharray="3 3" />
        <text fill="#EA7A4F" fontSize="9" fontFamily="'Archivo Black', sans-serif" letterSpacing="1.5">
          <textPath href="#stamp-circle" startOffset="0">
            {label}
          </textPath>
        </text>
        <text
          x="60"
          y="66"
          textAnchor="middle"
          fill="#EA7A4F"
          fontSize="18"
          fontFamily="'Permanent Marker', cursive"
        >
          SZN
        </text>
      </svg>
    </div>
  );
}

// Signature "billet" (ticket) — perforated notches on the sides + dashed divider.
export function Billet({ children, notchColor = "#F6F1E8", stamp = true, className = "" }) {
  return (
    <div className={`relative ${className}`} data-testid="billet-card">
      <div className="relative rounded-2xl border-2 border-[#14283A] bg-white shadow-[6px_6px_0_0_#14283A]">
        {/* side notches */}
        <span
          className="absolute -left-3 top-1/2 h-6 w-6 -translate-y-1/2 rounded-full border-2 border-[#14283A]"
          style={{ background: notchColor }}
          aria-hidden="true"
        />
        <span
          className="absolute -right-3 top-1/2 h-6 w-6 -translate-y-1/2 rounded-full border-2 border-[#14283A]"
          style={{ background: notchColor }}
          aria-hidden="true"
        />
        {children}
        {stamp && (
          <Stamp className="absolute -right-5 -top-6 h-20 w-20 sm:h-24 sm:w-24" />
        )}
      </div>
    </div>
  );
}
